export default {
    CalculationBasis: '11111111-1111-1111-1111-111111111111'
}